import script from "./AwardsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AwardsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__